"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AzureDevOpsApi = void 0;
var _authentication = require("../../../authentication");
var _config = require("../../../config");
var _PermissionsError = _interopRequireDefault(require("../errors/PermissionsError"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) {
              if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            }
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) {
      keys.push(key);
    }
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
var apiVersion = "5.1";
var AzureDevOpsApi = {
  getMruOrganizations: function () {
    var _getMruOrganizations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var apiHost;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              apiHost = _config.Config.getValue("UI:VSTS_USERS_API_URL");
              return _context.abrupt("return", executeRequest("".concat(apiHost, "/me/mostrecentlyaccessedhosts")));
            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    function getMruOrganizations() {
      return _getMruOrganizations.apply(this, arguments);
    }
    return getMruOrganizations;
  }(),
  getProjects: function () {
    var _getProjects = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(orgName) {
      var apiHost, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              apiHost = _config.Config.getValue("UI:VSTS_URL");
              _context2.prev = 1;
              _context2.next = 4;
              return executeRequest("".concat(apiHost, "/").concat(orgName, "/_apis/projects?$top=9999&api-version=").concat(apiVersion), t("artifactsPanel.projects.errors.projectsLoadFailed"));
            case 4:
              response = _context2.sent;
              _context2.next = 12;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              if (!(_context2.t0 instanceof _PermissionsError.default)) {
                _context2.next = 11;
                break;
              }
              throw new Error(t("artifactsPanel.projects.errors.projectsNotAuthorized"));
            case 11:
              throw _context2.t0;
            case 12:
              return _context2.abrupt("return", response.value);
            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    }));
    function getProjects(_x) {
      return _getProjects.apply(this, arguments);
    }
    return getProjects;
  }(),
  getMruProjects: function () {
    var _getMruProjects = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(organization) {
      var _response$value;
      var apiHost, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              apiHost = _config.Config.getValue("UI:VSTS_URL");
              _context3.next = 3;
              return executeRequest("".concat(apiHost, "/").concat(organization, "/_apis/Settings/Entries/me"));
            case 3:
              response = _context3.sent;
              if (!((_response$value = response.value) !== null && _response$value !== void 0 && _response$value["WebPlatform/Navigation/ProjectMRU"])) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return", response.value["WebPlatform/Navigation/ProjectMRU"]);
            case 6:
              return _context3.abrupt("return", []);
            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    function getMruProjects(_x2) {
      return _getMruProjects.apply(this, arguments);
    }
    return getMruProjects;
  }(),
  getRepositories: function () {
    var _getRepositories = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(orgName, projectName) {
      var url;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              url = "".concat(_config.Config.getValue("UI:VSTS_URL"), "/").concat(orgName, "/").concat(projectName, "/_apis/git/repositories?api-version=").concat(apiVersion);
              return _context4.abrupt("return", executeReposRequest(url));
            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    function getRepositories(_x3, _x4) {
      return _getRepositories.apply(this, arguments);
    }
    return getRepositories;
  }(),
  getRepository: function () {
    var _getRepository = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(orgName, projectId, repositoryId) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", executeReposRequest("".concat(_config.Config.getValue("UI:VSTS_URL"), "/").concat(orgName, "/").concat(projectId, "/_apis/git/repositories/").concat(repositoryId, "?api-version=").concat(apiVersion)));
            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    function getRepository(_x5, _x6, _x7) {
      return _getRepository.apply(this, arguments);
    }
    return getRepository;
  }(),
  getAreaPaths: function () {
    var _getAreaPaths = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(organizationName, projectId) {
      var apiHost;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              apiHost = _config.Config.getValue("UI:VSTS_URL");
              return _context6.abrupt("return", executeRequest("".concat(apiHost, "/").concat(organizationName, "/").concat(projectId, "/_apis/wit/classificationnodes/Areas?$depth=10&api-version=").concat(apiVersion), t("artifactsPanel.areaPaths.errors.areaPathNotFound")));
            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    function getAreaPaths(_x8, _x9) {
      return _getAreaPaths.apply(this, arguments);
    }
    return getAreaPaths;
  }(),
  getBuildDefinition: function () {
    var _getBuildDefinition = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(organizationName, projectId, buildDefinitionId) {
      var apiHost, response;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              apiHost = _config.Config.getValue("UI:VSTS_URL");
              _context7.next = 3;
              return executeRequest("".concat(apiHost, "/").concat(organizationName, "/").concat(projectId, "/_apis/build/definitions/").concat(buildDefinitionId), t("artifactsPanel.pipelines.errors.pipelinesLoadFailed"));
            case 3:
              response = _context7.sent;
              return _context7.abrupt("return", response);
            case 5:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    function getBuildDefinition(_x0, _x1, _x10) {
      return _getBuildDefinition.apply(this, arguments);
    }
    return getBuildDefinition;
  }(),
  getBuildDefs: function () {
    var _getBuildDefs = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(organizationName, projectId) {
      var apiHost, response;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              apiHost = _config.Config.getValue("UI:VSTS_URL");
              _context8.next = 3;
              return executeRequest("".concat(apiHost, "/").concat(organizationName, "/").concat(projectId, "/_apis/build/definitions?api-version=").concat(apiVersion), t("artifactsPanel.pipelines.errors.pipelinesLoadFailed"));
            case 3:
              response = _context8.sent;
              return _context8.abrupt("return", response.value);
            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    function getBuildDefs(_x11, _x12) {
      return _getBuildDefs.apply(this, arguments);
    }
    return getBuildDefs;
  }(),
  getBuildDefsWithBuildDefParameters: function () {
    var _getBuildDefsWithBuildDefParameters = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(organizationName, projectId, buildDefsApiParameters) {
      var apiHost, parameters, parameterString, response;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              apiHost = _config.Config.getValue("UI:VSTS_URL"); // accumulate parameters
              parameters = [];
              if (buildDefsApiParameters.repositoryId && buildDefsApiParameters.repositoryType) {
                parameters.push("repositoryId=".concat(buildDefsApiParameters.repositoryId, "&repositoryType=").concat(buildDefsApiParameters.repositoryType));
              }
              if (buildDefsApiParameters.includeAllProperties) {
                parameters.push('includeAllProperties=true');
              }

              // Stringify parameters
              parameterString = parameters.length ? parameters.join("&") + "&" : "";
              _context9.next = 7;
              return executeRequest("".concat(apiHost, "/").concat(organizationName, "/").concat(projectId, "/_apis/build/definitions?").concat(parameterString, "$api-version=").concat(apiVersion), t("artifactsPanel.pipelines.errors.pipelinesLoadFailed"));
            case 7:
              response = _context9.sent;
              return _context9.abrupt("return", response.value);
            case 9:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));
    function getBuildDefsWithBuildDefParameters(_x13, _x14, _x15) {
      return _getBuildDefsWithBuildDefParameters.apply(this, arguments);
    }
    return getBuildDefsWithBuildDefParameters;
  }(),
  getBuildDefinitionEditPermissions: function () {
    var _getBuildDefinitionEditPermissions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee0(organizationName, projectId, buildDefinition) {
      var buildSecurityNamespace, editBuildDefPermissionBit, apiHost, securityToken, permissionUrl, response, hasPermission;
      return _regeneratorRuntime().wrap(function _callee0$(_context0) {
        while (1) {
          switch (_context0.prev = _context0.next) {
            case 0:
              // Constants and the implementation taken from the APIs.
              // For details, see https://mseng.visualstudio.com/1ES/_git/space?path=/1es/lib/product-catalog-internals/src/ArtifactDataProviders/ADOBuildDefinitionDataProvider.cs&version=GBmain&line=43&lineEnd=44&lineStartColumn=1&lineEndColumn=56&lineStyle=plain&_a=contents
              buildSecurityNamespace = "33344D9C-FC72-4d6f-ABA5-FA317101A7E9";
              editBuildDefPermissionBit = 2048;
              apiHost = _config.Config.getValue("UI:VSTS_URL");
              securityToken = getSecurityToken(projectId, buildDefinition);
              permissionUrl = "".concat(apiHost, "/").concat(organizationName, "/_apis/permissions/").concat(buildSecurityNamespace, "/").concat(editBuildDefPermissionBit, "?tokens=").concat(securityToken, "&api-version=").concat(apiVersion);
              _context0.next = 7;
              return executeRequest(permissionUrl);
            case 7:
              response = _context0.sent;
              hasPermission = response.value[0];
              return _context0.abrupt("return", hasPermission);
            case 10:
            case "end":
              return _context0.stop();
          }
        }
      }, _callee0);
    }));
    function getBuildDefinitionEditPermissions(_x16, _x17, _x18) {
      return _getBuildDefinitionEditPermissions.apply(this, arguments);
    }
    return getBuildDefinitionEditPermissions;
  }(),
  getFavoriteBuildDefs: function () {
    var _getFavoriteBuildDefs = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee1(organizationName, projectId) {
      var apiHost, response;
      return _regeneratorRuntime().wrap(function _callee1$(_context1) {
        while (1) {
          switch (_context1.prev = _context1.next) {
            case 0:
              apiHost = _config.Config.getValue("UI:VSTS_URL");
              _context1.next = 3;
              return executeRequest("".concat(apiHost, "/").concat(organizationName, "/_apis/Favorite/Favorites?artifactType=Microsoft.TeamFoundation.Build.Definition&artifactScopeType=Project&artifactScopeId=").concat(projectId), t("artifactsPanel.pipelines.errors.favoritePipelinesLoadFailed"));
            case 3:
              response = _context1.sent;
              return _context1.abrupt("return", response.value);
            case 5:
            case "end":
              return _context1.stop();
          }
        }
      }, _callee1);
    }));
    function getFavoriteBuildDefs(_x19, _x20) {
      return _getFavoriteBuildDefs.apply(this, arguments);
    }
    return getFavoriteBuildDefs;
  }(),
  searchBuildDefs: function () {
    var _searchBuildDefs = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(organizationName, projectId, searchText) {
      var apiHost, response, result, idSearchResponse;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              apiHost = _config.Config.getValue("UI:VSTS_URL");
              _context10.next = 3;
              return executeRequest("".concat(apiHost, "/").concat(organizationName, "/").concat(projectId, "/_apis/build/definitions?name=*").concat(searchText, "*&api-version=").concat(apiVersion), t("artifactsPanel.pipelines.errors.pipelinesSearchFailed"));
            case 3:
              response = _context10.sent;
              result = response.value;
              if (!Number(searchText)) {
                _context10.next = 10;
                break;
              }
              _context10.next = 8;
              return executeRequest("".concat(apiHost, "/").concat(organizationName, "/").concat(projectId, "/_apis/build/definitions?definitionIds=").concat(searchText, "&api-version=").concat(apiVersion), t("artifactsPanel.pipelines.errors.pipelinesSearchFailed"));
            case 8:
              idSearchResponse = _context10.sent;
              result = result.concat(idSearchResponse.value);
            case 10:
              return _context10.abrupt("return", result);
            case 11:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));
    function searchBuildDefs(_x21, _x22, _x23) {
      return _searchBuildDefs.apply(this, arguments);
    }
    return searchBuildDefs;
  }(),
  getReleaseDefs: function () {
    var _getReleaseDefs = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(organizationName, projectId) {
      var apiHost, response;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              apiHost = _config.Config.getValue("UI:VSRM_URL");
              _context11.next = 3;
              return executeRequest("".concat(apiHost, "/").concat(organizationName, "/").concat(projectId, "/_apis/release/definitions?api-version=").concat(apiVersion), t("artifactsPanel.pipelines.errors.pipelinesLoadFailed"));
            case 3:
              response = _context11.sent;
              return _context11.abrupt("return", response.value);
            case 5:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));
    function getReleaseDefs(_x24, _x25) {
      return _getReleaseDefs.apply(this, arguments);
    }
    return getReleaseDefs;
  }(),
  searchReleaseDefs: function () {
    var _searchReleaseDefs = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(organizationName, projectId, searchText) {
      var apiHost, response, result, idSearchResponse;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              apiHost = _config.Config.getValue("UI:VSRM_URL");
              _context12.next = 3;
              return executeRequest("".concat(apiHost, "/").concat(organizationName, "/").concat(projectId, "/_apis/release/definitions?searchText=").concat(searchText, "&api-version=").concat(apiVersion), t("artifactsPanel.pipelines.errors.pipelinesSearchFailed"));
            case 3:
              response = _context12.sent;
              result = response.value;
              if (!Number(searchText)) {
                _context12.next = 10;
                break;
              }
              _context12.next = 8;
              return executeRequest("".concat(apiHost, "/").concat(organizationName, "/").concat(projectId, "/_apis/release/definitions?definitionIdFilter=").concat(searchText, "&api-version=").concat(apiVersion), t("artifactsPanel.pipelines.errors.pipelinesSearchFailed"));
            case 8:
              idSearchResponse = _context12.sent;
              result = result.concat(idSearchResponse.value);
            case 10:
              return _context12.abrupt("return", result);
            case 11:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));
    function searchReleaseDefs(_x26, _x27, _x28) {
      return _searchReleaseDefs.apply(this, arguments);
    }
    return searchReleaseDefs;
  }(),
  getFavoriteReleaseDefs: function () {
    var _getFavoriteReleaseDefs = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(organizationName, projectId) {
      var apiHost, response;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              apiHost = _config.Config.getValue("UI:VSTS_URL");
              _context13.next = 3;
              return executeRequest("".concat(apiHost, "/").concat(organizationName, "/_apis/Favorite/Favorites?artifactType=Microsoft.TeamFoundation.Release.Definition&artifactScopeType=Project&artifactScopeId=").concat(projectId), t("artifactsPanel.pipelines.errors.favoritePipelinesLoadFailed"));
            case 3:
              response = _context13.sent;
              return _context13.abrupt("return", response.value);
            case 5:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));
    function getFavoriteReleaseDefs(_x29, _x30) {
      return _getFavoriteReleaseDefs.apply(this, arguments);
    }
    return getFavoriteReleaseDefs;
  }(),
  // function markMruProjects(allProjects: Project[], mruProjects: IMruProject[]) {
  //     const mruProjectsDict = _.keyBy(mruProjects, "projectId");
  //     allProjects.forEach(p => {
  //         if (mruProjectsDict[p.id]) {
  //             p.isMru = true;
  //         }
  //     });
  // }

  getMruAreaPathIds: function () {
    var _getMruAreaPathIds = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(organization, project) {
      var _response$value2;
      var apiHost, response;
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              apiHost = _config.Config.getValue("UI:VSTS_URL");
              _context14.next = 3;
              return executeRequest("".concat(apiHost, "/").concat(organization, "/_apis/Settings/project/").concat(project.id, "/Entries/me/ClassificationFieldsMru"));
            case 3:
              response = _context14.sent;
              if (!((_response$value2 = response.value) !== null && _response$value2 !== void 0 && _response$value2.AreaPath)) {
                _context14.next = 6;
                break;
              }
              return _context14.abrupt("return", response.value.AreaPath);
            case 6:
              return _context14.abrupt("return", []);
            case 7:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));
    function getMruAreaPathIds(_x31, _x32) {
      return _getMruAreaPathIds.apply(this, arguments);
    }
    return getMruAreaPathIds;
  }()
};
exports.AzureDevOpsApi = AzureDevOpsApi;
var getSecurityToken = function getSecurityToken(projectId, buildDefinition) {
  var securityToken = projectId;
  var buildDefinitionPath = buildDefinition.path;
  var securityTokenPath = getSecurityTokenPath(buildDefinitionPath);
  if (!(securityTokenPath === "" || securityTokenPath === null)) {
    securityToken = securityToken + "/" + securityTokenPath;
  }
  securityToken = securityToken + "/" + buildDefinition["id"];
  return securityToken;
};
var getSecurityTokenPath = function getSecurityTokenPath(buildDefinitionPath) {
  if (!buildDefinitionPath) {
    return "";
  }
  var components = buildDefinitionPath.split('\\').filter(function (c) {
    return c !== "";
  });
  if (components.length === 0) {
    return "";
  }
  return components.join("/");
};
function makeRequest(_x33) {
  return _makeRequest.apply(this, arguments);
}
function _makeRequest() {
  _makeRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(url) {
    var adToken, request;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return _authentication.AuthTokenProvider.acquireVstsToken();
          case 2:
            adToken = _context15.sent;
            request = new Request(url, {
              method: "GET",
              headers: {
                Authorization: "Bearer ".concat(adToken)
              }
            });
            return _context15.abrupt("return", fetch(request));
          case 5:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _makeRequest.apply(this, arguments);
}
function executeRequest(_x34, _x35) {
  return _executeRequest.apply(this, arguments);
}
function _executeRequest() {
  _executeRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(requestUrl, customizedError) {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return makeRequest(requestUrl);
          case 2:
            response = _context16.sent;
            if (!(response.status === 200)) {
              _context16.next = 7;
              break;
            }
            return _context16.abrupt("return", response.json());
          case 7:
            if (!(response.status === 401)) {
              _context16.next = 11;
              break;
            }
            throw new _PermissionsError.default(t("artifactsPanel.permissionError"));
          case 11:
            if (!customizedError) {
              _context16.next = 13;
              break;
            }
            throw new Error(customizedError);
          case 13:
            _context16.next = 15;
            return response.json();
          case 15:
            data = _context16.sent;
            throw new Error(data.message);
          case 17:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _executeRequest.apply(this, arguments);
}
function executeReposRequest(_x36) {
  return _executeReposRequest.apply(this, arguments);
}
function _executeReposRequest() {
  _executeReposRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(requestUrl) {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return makeRequest(requestUrl);
          case 2:
            response = _context17.sent;
            _context17.next = 5;
            return response.json();
          case 5:
            data = _context17.sent;
            if (!response.ok) {
              _context17.next = 10;
              break;
            }
            return _context17.abrupt("return", data);
          case 10:
            if (![401, 403, 404].includes(response.status)) {
              _context17.next = 14;
              break;
            }
            throw new _PermissionsError.default(data.message);
          case 14:
            throw new Error(data.message);
          case 15:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _executeReposRequest.apply(this, arguments);
}